<template>
	<span v-if="file" class="icon" :class="classes" :style="style" v-html="src"></span>
</template>

<script>

export default {
	name: 'Icon',
	data () {
		return {

		}
	},
	props: {
		file: false,
		invert: false,
		size: {
			default: 24
		}
	},
	computed: {
		classes: function() {
			var classes = [];
			if (this.invert) classes.push('invert');
			return classes;
		},
		style: function() {
			var style = { width: this.size + 'px', height: this.size + 'px' };
			return style;
		},
		src: function() {
			return require('../../assets/img/' + this.file + '.svg');
		}
	}
}
</script>

<style lang="stylus">

.icon
	display inline-block
	vertical-align middle
	&.invert
		svg
			filter invert(1)
	svg
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		height 100% !important
		width 100% !important

</style>



// WEBPACK FOOTER //
// src/components/ui/Icon.vue